/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ChartBean', 'model/IStatisticsResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ChartBean'), require('./IStatisticsResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.StatisticsResponse = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.ChartBean, root.BpmbuildUatDsappspotcom.IStatisticsResponse);
  }
}(this, function(ApiClient, ChartBean, IStatisticsResponse) {
  'use strict';

  /**
   * The StatisticsResponse model module.
   * @module model/StatisticsResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StatisticsResponse</code>.
   * @alias module:model/StatisticsResponse
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StatisticsResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StatisticsResponse} obj Optional instance to populate.
   * @return {module:model/StatisticsResponse} The populated <code>StatisticsResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('chartType'))
        obj.chartType = ApiClient.convertToType(data['chartType'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('comparisonString'))
        obj.comparisonString = ApiClient.convertToType(data['comparisonString'], 'String');
      if (data.hasOwnProperty('comparisonType'))
        obj.comparisonType = ApiClient.convertToType(data['comparisonType'], 'String');
      if (data.hasOwnProperty('customComparisonDateFrom'))
        obj.customComparisonDateFrom = ApiClient.convertToType(data['customComparisonDateFrom'], 'Date');
      if (data.hasOwnProperty('customComparisonDateTo'))
        obj.customComparisonDateTo = ApiClient.convertToType(data['customComparisonDateTo'], 'Date');
      if (data.hasOwnProperty('customOptionDateFrom'))
        obj.customOptionDateFrom = ApiClient.convertToType(data['customOptionDateFrom'], 'Date');
      if (data.hasOwnProperty('customOptionDateTo'))
        obj.customOptionDateTo = ApiClient.convertToType(data['customOptionDateTo'], 'Date');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('optionString'))
        obj.optionString = ApiClient.convertToType(data['optionString'], 'String');
      if (data.hasOwnProperty('productList'))
        obj.productList = ApiClient.convertToType(data['productList'], ['String']);
      if (data.hasOwnProperty('reportType'))
        obj.reportType = ApiClient.convertToType(data['reportType'], 'String');
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
      if (data.hasOwnProperty('statisticsDisplay'))
        obj.statisticsDisplay = ApiClient.convertToType(data['statisticsDisplay'], [ChartBean]);
      if (data.hasOwnProperty('statisticsList'))
        obj.statisticsList = ApiClient.convertToType(data['statisticsList'], [IStatisticsResponse]);
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {module:model/StatisticsResponse.ChartTypeEnum} chartType
   */
  exports.prototype.chartType = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {module:model/StatisticsResponse.ComparisonStringEnum} comparisonString
   */
  exports.prototype.comparisonString = undefined;

  /**
   * @member {module:model/StatisticsResponse.ComparisonTypeEnum} comparisonType
   */
  exports.prototype.comparisonType = undefined;

  /**
   * @member {Date} customComparisonDateFrom
   */
  exports.prototype.customComparisonDateFrom = undefined;

  /**
   * @member {Date} customComparisonDateTo
   */
  exports.prototype.customComparisonDateTo = undefined;

  /**
   * @member {Date} customOptionDateFrom
   */
  exports.prototype.customOptionDateFrom = undefined;

  /**
   * @member {Date} customOptionDateTo
   */
  exports.prototype.customOptionDateTo = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {module:model/StatisticsResponse.OptionStringEnum} optionString
   */
  exports.prototype.optionString = undefined;

  /**
   * @member {Array.<String>} productList
   */
  exports.prototype.productList = undefined;

  /**
   * @member {module:model/StatisticsResponse.ReportTypeEnum} reportType
   */
  exports.prototype.reportType = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;

  /**
   * @member {Array.<module:model/ChartBean>} statisticsDisplay
   */
  exports.prototype.statisticsDisplay = undefined;

  /**
   * @member {Array.<module:model/IStatisticsResponse>} statisticsList
   */
  exports.prototype.statisticsList = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;


  /**
   * Allowed values for the <code>chartType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ChartTypeEnum = {
    /**
     * value: "PIE"
     * @const
     */
    PIE: "PIE",

    /**
     * value: "AREA"
     * @const
     */
    AREA: "AREA",

    /**
     * value: "BAR"
     * @const
     */
    BAR: "BAR",

    /**
     * value: "TIMELINE"
     * @const
     */
    TIMELINE: "TIMELINE",

    /**
     * value: "GUAGE"
     * @const
     */
    GUAGE: "GUAGE",

    /**
     * value: "COMBO"
     * @const
     */
    COMBO: "COMBO",

    /**
     * value: "GANTT"
     * @const
     */
    GANTT: "GANTT",

    /**
     * value: "BUBBLE"
     * @const
     */
    BUBBLE: "BUBBLE"
  };


  /**
   * Allowed values for the <code>comparisonString</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ComparisonStringEnum = {
    /**
     * value: "PREVIOUSDAY"
     * @const
     */
    PREVIOUSDAY: "PREVIOUSDAY",

    /**
     * value: "SAMEDAYLASTWEEK"
     * @const
     */
    SAMEDAYLASTWEEK: "SAMEDAYLASTWEEK",

    /**
     * value: "SAMEDAYLASTYEAR"
     * @const
     */
    SAMEDAYLASTYEAR: "SAMEDAYLASTYEAR",

    /**
     * value: "SAMEDAYOFWEEKLASTYEAR"
     * @const
     */
    SAMEDAYOFWEEKLASTYEAR: "SAMEDAYOFWEEKLASTYEAR",

    /**
     * value: "PREVIOUSPERIOD"
     * @const
     */
    PREVIOUSPERIOD: "PREVIOUSPERIOD",

    /**
     * value: "FOURWEEKSAGO"
     * @const
     */
    FOURWEEKSAGO: "FOURWEEKSAGO",

    /**
     * value: "SAMEWEEKLASTYEAR"
     * @const
     */
    SAMEWEEKLASTYEAR: "SAMEWEEKLASTYEAR",

    /**
     * value: "SAMEPERIODLASTYEAR"
     * @const
     */
    SAMEPERIODLASTYEAR: "SAMEPERIODLASTYEAR",

    /**
     * value: "FIFTYTWOWEEKSAGO"
     * @const
     */
    FIFTYTWOWEEKSAGO: "FIFTYTWOWEEKSAGO",

    /**
     * value: "PREVIOUSYEAR"
     * @const
     */
    PREVIOUSYEAR: "PREVIOUSYEAR"
  };


  /**
   * Allowed values for the <code>comparisonType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ComparisonTypeEnum = {
    /**
     * value: "DAY"
     * @const
     */
    DAY: "DAY",

    /**
     * value: "WEEK"
     * @const
     */
    WEEK: "WEEK",

    /**
     * value: "MONTH"
     * @const
     */
    MONTH: "MONTH",

    /**
     * value: "YEAR"
     * @const
     */
    YEAR: "YEAR",

    /**
     * value: "CUSTOM"
     * @const
     */
    CUSTOM: "CUSTOM"
  };


  /**
   * Allowed values for the <code>optionString</code> property.
   * @enum {String}
   * @readonly
   */
  exports.OptionStringEnum = {
    /**
     * value: "TODAY"
     * @const
     */
    TODAY: "TODAY",

    /**
     * value: "YESTERDAY"
     * @const
     */
    YESTERDAY: "YESTERDAY",

    /**
     * value: "LAST7DAYS"
     * @const
     */
    lAST7DAYS: "LAST7DAYS",

    /**
     * value: "THISWEEK"
     * @const
     */
    THISWEEK: "THISWEEK",

    /**
     * value: "LASTWEEK"
     * @const
     */
    LASTWEEK: "LASTWEEK",

    /**
     * value: "LAST30DAYS"
     * @const
     */
    lAST30DAYS: "LAST30DAYS",

    /**
     * value: "THISMONTH"
     * @const
     */
    THISMONTH: "THISMONTH",

    /**
     * value: "LASTMONTH"
     * @const
     */
    LASTMONTH: "LASTMONTH",

    /**
     * value: "LAST365DAYS"
     * @const
     */
    lAST365DAYS: "LAST365DAYS",

    /**
     * value: "THISYEAR"
     * @const
     */
    THISYEAR: "THISYEAR",

    /**
     * value: "LASTYEAR"
     * @const
     */
    LASTYEAR: "LASTYEAR"
  };


  /**
   * Allowed values for the <code>reportType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ReportTypeEnum = {
    /**
     * value: "LEADTIME"
     * @const
     */
    LEADTIME: "LEADTIME",

    /**
     * value: "CYCLETIME"
     * @const
     */
    CYCLETIME: "CYCLETIME"
  };

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/StatisticsResponse.js